import { ref, computed } from "vue"

export const SMS_VARIABLES = [
  "{{account_number}}",
  "{{recipient_name}}",
] as const

export type SmsVariable = (typeof SMS_VARIABLES)[number]

export const MAX_LENGTH = 612

// GSM-7 encoding: 160 chars for single SMS, then 153 chars per concatenated segment
const SINGLE_SEGMENT_LIMIT = 160
const TWO_SEGMENT_LIMIT = 306 // 153 * 2
const THREE_SEGMENT_LIMIT = 459 // 153 * 3

export function getSegmentCount(charCount: number): number {
  if (charCount === 0) return 0
  if (charCount <= SINGLE_SEGMENT_LIMIT) return 1
  if (charCount <= TWO_SEGMENT_LIMIT) return 2
  if (charCount <= THREE_SEGMENT_LIMIT) return 3
  return 4
}

export function useMessageEditor() {
  const messageText = ref("")

  const charCount = computed(() => messageText.value.length)

  const segmentCount = computed(() => getSegmentCount(charCount.value))

  const isValid = computed(() => {
    return charCount.value > 0 && charCount.value <= MAX_LENGTH
  })

  function insertVariable(variable: SmsVariable, cursorPosition: number) {
    const before = messageText.value.slice(0, cursorPosition)
    const after = messageText.value.slice(cursorPosition)
    const newText = before + variable + after

    if (newText.length <= MAX_LENGTH) {
      messageText.value = newText
    }
  }

  function reset() {
    messageText.value = ""
  }

  return {
    messageText,
    charCount,
    segmentCount,
    isValid,
    insertVariable,
    reset,
  }
}
